import React, { useState } from "react";
import Name from "../assets/firstName.png";
import Email from "../assets/Email.png";
import Phone from "../assets/Phone.png";
import address from "../assets/address.png";
import { FormInput } from "../Component/FormInput";
import { getNames } from "country-list";
import { IoMdArrowDropdown } from "react-icons/io";
import ProgressHeader from "../Component/ProgressHeader";
import FileInput from "../Component/FileInput";
import Calender from "../Component/Calender";
import "./Pages.css";
import { useFormData } from "../Context/FormContext";
import { EmergencyContact } from "./EmergencyContact";
import { MedicalInformation } from "./MedicalInformation";
import { Membership } from "./Membership";

const PersonalInformation = () => {
	const { formData, setFormData } = useFormData();
	const [errors, setErrors] = useState({});

	const countries = getNames();
	const MAX_SIZE_MB = 1;
	const validTypes = ["application/pdf", "image/jpeg", "image/png"];


	const validateFile = (file, type) => {
		if (!file) return `${type} is required.`;
		if (!validTypes.includes(file.type))
			return `Invalid file type for ${type}.`;
		if (file.size > MAX_SIZE_MB * 1024 * 1024)
			return `${type} must be 1MB or smaller.`;
		return "";
	};

	const handleFileChange = (e, type) => {
		const uploaded = e.target.files[0];
		if (!uploaded) return;

		const errorMsg = validateFile(uploaded, type);
		setErrors((prev) => ({ ...prev, [type]: errorMsg || "" }));

		if (!errorMsg) {
			const fieldKey = type === "Civil ID Image" ? "civilIdImage" : "photoProof";
			setFormData((prev) => ({ ...prev, [fieldKey]: uploaded }));
		}
	};


	const removeFile = (type) => {
		const fieldKey = type === "Civil ID Image" ? "civilIdImage" : "photoProof";
		setFormData((prev) => ({ ...prev, [fieldKey]: null }));
		setErrors((prev) => ({ ...prev, [type]: "" }));
	};



	const validateName = (name, field) => {
		if (!name) return `${field} is required`;
		if (!/^[A-Za-z\s]+$/.test(name))
			return `${field} should contain only letters`;
		return "";
	};

	const validateEmail = (emailAddress) => {
		if (!emailAddress) return "Email is required";
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(emailAddress)) return "Invalid email format";
		return "";
	};

	const validatePhone = (phoneNumber) => {
		if (!phoneNumber) return "phoneNumber number is required";
		// if (!/^\d{10}$/.test(phoneNumber)) return "Phone number must be 10 digits";
		// return "";
	};

	const validateWhatsapp = (whatsAppNumber) => {
		if (!whatsAppNumber) return "WhatsappNumber number is required";
		// if (!/^\d{10}$/.test(whatsAppNumber)) return "Phone number must be 10 digits";
		// return "";
	};

	const validateGender = (gender) => (!gender ? "Gender is required" : "");
	const validateAddress = (addr) => {
		if (!addr) return "Street Address is required";
		if (addr.length < 5) return "Address should be at least 5 characters";
		return "";
	};
	const validateCity = (city) => {
		if (!city) return "City is required";
		if (!/^[A-Za-z\s]+$/.test(city)) return "City should contain only letters";
		return "";
	};
	const validateState = (state) =>
		!state || state === "Choose State or province..."
			? "State is required"
			: "";
	const validatePostal = (zipcode) => {
		if (!zipcode) return "Postal code is required";
		// if (!/^\d{5,6}$/.test(zipcode)) return "Invalid zipcode code";
		// return "";
	};
	const validateCountry = (country) =>
		!country || country === "Choose Country..." ? "Country is required" : "";
	const validateCivilId = (id) => (!id ? "Civil ID is required" : "");

	const validateDOB = (dateOfBirth) => {
		if (!dateOfBirth) return "Date of Birth is required";
		const today = new Date();
		if (new Date(dateOfBirth) > today) return "DOB cannot be in the future";
		return "";
	};

	const validateExpiryDate = (idExpireDate) => {
		if (!idExpireDate) return "Expiry Date is required";
		const today = new Date();
		if (new Date(idExpireDate) < today) return "Expiry date cannot be in the past";
		return "";
	};

	const handleChange = (e) => {
		const { name, value } = e.target;

		let newValue = value;


		// if (name === "phoneNumber" || name === "whatsAppNumber") {
		// 	newValue = newValue.replace(/\D/g, "");
		// 	if (newValue.length > 10) {
		// 		newValue = newValue.slice(0, 10);
		// 	}
		// }

		setFormData((prev) => ({
			...prev,
			personalInformation: {
				...prev.personalInformation,
				[name]: newValue,
			},
		}));


		let errorMsg = "";
		switch (name) {
			case "firstName":
				errorMsg = validateName(newValue, "First Name");
				break;
			case "lastName":
				errorMsg = validateName(newValue, "Last Name");
				break;
			case "emailAddress":
				errorMsg = validateEmail(newValue);
				break;
			case "phoneNumber":
				errorMsg = validatePhone(newValue);
				break;
			case "whatsAppNumber":
				errorMsg = validateWhatsapp(newValue);
				break;
			case "dateOfBirth":
				errorMsg = validateDOB(newValue);
				break;
			case "gender":
				errorMsg = validateGender(newValue);
				break;
			case "address":
				errorMsg = validateAddress(newValue);
				break;
			case "city":
				errorMsg = validateCity(newValue);
				break;
			case "state":
				errorMsg = validateState(newValue);
				break;
			case "zipcode":
				errorMsg = validatePostal(newValue);
				break;
			case "country":
				errorMsg = validateCountry(newValue);
				break;
			case "civilIdNumber":
				errorMsg = validateCivilId(newValue);
				break;
			case "idExpireDate":
				errorMsg = validateExpiryDate(newValue);
				break;
			default:
				break;
		}
		setErrors((prev) => ({ ...prev, [name]: errorMsg }));
	};


	// const handleSubmit = (e) => {
	// 	e.preventDefault();

	// 	const newErrors = {
	// 		firstName: validateName(formData.personalInformation.firstName, "First Name"),
	// 		lastName: validateName(formData.personalInformation.lastName, "Last Name"),
	// 		emailAddress: validateEmail(formData.personalInformation.emailAddress),
	// 		phoneNumber: validatePhone(formData.personalInformation.phoneNumber),
	// 		whatsAppNumber: validateWhatsapp(formData.personalInformation.whatsAppNumber),
	// 		dateOfBirth: validateDOB(formData.personalInformation.dateOfBirth),
	// 		gender: validateGender(formData.personalInformation.gender),
	// 		address: validateAddress(formData.personalInformation.address),
	// 		city: validateCity(formData.personalInformation.city),
	// 		state: validateState(formData.personalInformation.state),
	// 		zipcode: validatePostal(formData.personalInformation.zipcode),
	// 		country: validateCountry(formData.personalInformation.country),
	// 		civilIdNumber: validateCivilId(formData.personalInformation.civilIdNumber),
	// 		idExpireDate: validateExpiryDate(formData.personalInformation.idExpireDate),
	// 		"Civil ID Image": validateFile(formData.civilIdImage, "Civil ID Image"),
	// 		"Photo Proof": validateFile(formData.photoProof, "Photo Proof"),
	// 	};

	// 	setErrors(newErrors);

	// 	const hasErrors = Object.values(newErrors).some((msg) => msg);
	// 	if (hasErrors) return;

	// 	navigate("/registration/emergencycontact");
	// };


	return (
		<div className="contents">
			<ProgressHeader
				title="MEMBER "
				nextTitle="ENTROLLMENT FORM"
				// currentStep={1}
				// totalSteps={4}
			/>
			<form
				// onSubmit={handleSubmit}
				className="grid grid-cols-1 md:grid-cols-2 md:gap-x-12 lg:gap-x-44 gap-y-8  text-white bg-[#0C0C0C] px-4 pt-6 pb-4 md:px-24 md:pt-16 md:pb-8 font-lufga relative"
			>
				<div>
					<FormInput
						label="First Name"
						placeholder="Enter your first name..."
						name="firstName"
						onChange={handleChange}
						icon={Name}
						value={formData.personalInformation.firstName || ""}
					/>
					{errors.firstName && (
						<p className="text-red-500 text-sm mt-1">{errors.firstName}</p>
					)}
				</div>

				<div>
					<FormInput
						label="Last Name"
						placeholder="Enter your last name..."
						name="lastName"
						onChange={handleChange}
						icon={Name}
						value={formData.personalInformation.lastName || ""}
					/>
					{errors.lastName && (
						<p className="text-red-500 text-sm mt-1">{errors.lastName}</p>
					)}
				</div>

				<div>
					<FormInput
						label="Email Address"
						placeholder="Enter email address..."
						name="emailAddress"
						onChange={handleChange}
						icon={Email}
						value={formData.personalInformation.emailAddress || ""}
					/>
					{errors.emailAddress && (
						<p className="text-red-500 text-sm mt-1">{errors.emailAddress}</p>
					)}
				</div>

				<div>
					<FormInput
						label="Phone Number"
						placeholder="Enter phone number..."
						name="phoneNumber"
						onChange={handleChange}
						value={formData.personalInformation.phoneNumber || ""}
						icon={Phone}
						inputMode="numeric"
                    	onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
					/>
					{errors.phoneNumber && (
						<p className="text-red-500 text-sm mt-1">{errors.phoneNumber}</p>
					)}
				</div>


				<div>
					<FormInput
						label="Whatsapp Number"
						placeholder="Enter Whatsapp number..."
						name="whatsAppNumber"
						onChange={handleChange}
						value={formData.personalInformation.whatsAppNumber || ""}
						icon={Phone}
						inputMode="numeric"
						onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
						// maxLength={10}
					/>
					{errors.whatsAppNumber && (
						<p className="text-red-500 text-sm mt-1">{errors.whatsAppNumber}</p>
					)}
				</div>

				<div className="flex flex-col gap-2 w-full mt-4 md:mt-3 lg:mt-0">
					<label className="text-[#ffffff] text-[16px] lg:text-[20px] font-lufga">
						Date of Birth
					</label>
					<div className="bg-[#282828] text-white px-6 py-4 rounded-full border-none w-full text-[14px] lg:text-[18px]">
						<Calender
							value={formData.personalInformation.dateOfBirth}
							onChange={(date) => {
								setFormData((prev) => ({
									...prev,
									personalInformation: { ...prev.personalInformation, dateOfBirth: date }
								}));
								setErrors((prev) => ({ ...prev, dateOfBirth: "" }));
							}}
							placeholder="YYYY-MM-DD"
							disableFuture={true}
							maxDate={new Date()}
						/>
					</div>
					{errors.dateOfBirth && (
						<p className="text-red-500 text-sm mt-1">{errors.dateOfBirth}</p>
					)}
				</div>

				<div className="mt-4 md:mt-0">
					<label className="text-[16px] lg:text-[20px]">Gender</label>
					<div className="flex flex-col gap-3 md:flex md:flex-row md:gap-6 mt-5 md:mt-10 text-[#949494]">
						{["Male", "Female", "Other"].map((option) => (
							<label
								key={option}
								className="flex items-center text-[14px] md:text-[18px] gap-2 cursor-pointer"
							>
								<input
									type="radio"
									name="gender"
									value={option}
									onChange={handleChange}
									checked={formData.personalInformation.gender === option}
									className="hidden"
								/>
								<div
									className={`w-6 h-6 rounded-full flex items-center justify-center 
                    ${formData.personalInformation.gender === option
											? "bg-[#D3631D]"
											: "bg-[#2c2c2c]"
										}`}
								>
									<div className="w-2.5 h-2.5 bg-white rounded-full" />
								</div>
								<span>{option}</span>
							</label>
						))}
					</div>
					{errors.gender && (
						<p className="text-red-500 text-sm mt-1">{errors.gender}</p>
					)}
				</div>
				<div>
					<FormInput
						label="Address"
						placeholder="Enter Address..."
						name="address"
						onChange={handleChange}
						icon={address}
						value={formData.personalInformation.address || ""}
					/>
					<p className="text-xs pt-2 text-[#CECECE]">Street Address</p>
					{errors.address && (
						<p className="text-red-500 text-sm mt-1">{errors.address}</p>
					)}
				</div>
				{/* <div className="mt-4 md:mt-0">
					<input
						type="text"
						name="city"
						placeholder="Enter City name..."
						value={formData.personalInformation.city || ""}
						onChange={handleChange}
						className="no-autofill-bg bg-[#282828] border-none outline-none text-white w-full rounded-full px-6 py-4 placeholder-[#949494] text-[14px] md:text-[18px] font-lufga"
					/>
					<p className="text-xs pt-2 text-[#CECECE]">City</p>
					{errors.city && (
						<p className="text-red-500 text-sm mt-1">{errors.city}</p>
					)}
				</div>

				<div className="mt-4 md:mt-0">
					<input
						type="text"
						name="state"
						placeholder="Enter State or Province..."
						value={formData.personalInformation.state}
						onChange={handleChange}
						className="no-autofill-bg w-full bg-[#282828] text-[#ffffff]  rounded-full px-6 py-4 placeholder-[#949494] outline-none border-none text-[14px] md:text-[18px] font-lufga"
					/>
					<p className=" text-xs pt-2 font-lufga text-[#CECECE]">
						State / Province
					</p>
					{errors.state && (
						<p className="text-red-500 text-sm mt-1">{errors.state}</p>
					)}
				</div> */}
				{/* <div className="mt-4 md:mt-0">
					<input
						name="zipcode"
						placeholder="Enter Postal or zipcode..."
						value={formData.personalInformation.zipcode || ""}
						onChange={handleChange}
						onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
						className="no-autofill-bg bg-[#282828] border-none outline-none text-white w-full rounded-full px-6 py-4 text-[14px] md:text-[18px] placeholder-[#949494]  font-lufga"
					/>
					<p className="text-xs pt-2 font-lufga text-[#CECECE]">
						Postal / Zip Code
					</p>
					{errors.zipcode && (
						<p className="text-red-500 text-sm mt-1">{errors.zipcode}</p>
					)}
				</div> */}

				<div className="relative mt-4 md:mt-0">
					<select
						name="country"
						value={formData.personalInformation.country}
						onChange={handleChange}
						className="no-autofill-bg bg-[#282828] text-[#949494] placeholder-[#949494] border-none font-lufga text-[14px] md:text-[18px] appearance-none outline-none w-full rounded-full px-6 py-4"
					>
						<option>Choose Nationality...</option>
						{countries.map((country) => (
							<option key={country} value={country}>
								{country}
							</option>
						))}
					</select>
					<div className="pointer-events-none absolute right-8 top-4 transform -translate-y-1/2 text-white text-sm">
						<IoMdArrowDropdown className="w-6 h-6 " />
					</div>
					<p className="text-xs pt-2 font-lufga text-[#CECECE]">Nationality</p>
					{errors.country && (
						<p className="text-red-500 text-sm mt-1">{errors.country}</p>
					)}
				</div>
				<div className="mt-4 md:mt-0">
					<input
						type="text"
						name="civilIdNumber"
						placeholder="Enter Civil ID..."
						value={formData.personalInformation.civilIdNumber || ""}
						onChange={handleChange}
						className="no-autofill-bg bg-[#282828] border-none font-lufga outline-none text-[#FFFFFF] w-full rounded-full px-6 py-4 placeholder-[#949494]text-[16px] md:text-[18px] "
					/>
					<p className="text-xs pt-2 font-lufga text-[#CECECE]">
						Civil ID Number
					</p>
					{errors.civilIdNumber && (
						<p className="text-red-500 text-sm mt-1">{errors.civilIdNumber}</p>
					)}
				</div>

				<div className="mt-4 md:mt-0">
					<label className="text-[#FFFFFF] text-[16px] lg:text-[20px] font-lufga ">
						ID Expiry Date
					</label>
					<div className="bg-[#282828] text-white px-6 py-4 rounded-full border-none w-full mt-2 text-[14px] md:text-[18px]">
						<Calender
							value={formData.personalInformation.idExpireDate}
							onChange={(idExpireDate) => {
								setFormData((prev) => ({
									...prev,
									personalInformation: {
										...prev.personalInformation,
										idExpireDate: idExpireDate,
									},
								}));
								setErrors((prev) => ({ ...prev, idExpireDate: "" }));
							}}

							placeholder="YYYY-MM-DD"
							disablePast={true}
						/>
					</div>
					{errors.idExpireDate && (
						<p className="text-red-500 text-sm mt-1">{errors.idExpireDate}</p>
					)}
				</div>
				<div className="mt-4 md:mt-0">
					<FileInput
						label="Civil ID Image"
						file={formData.civilIdImage}
						type="Civil ID Image"
						error={errors["Civil ID Image"]}
						onChange={handleFileChange}
						onRemove={removeFile}
						onSelect={(e) => { const uploadedFile = e.files?.[0]; setFormData({ ...formData, civilIdImage: uploadedFile }) }}
					/>
				</div>

				<div className="mt-4 md:mt-0">
					<FileInput
						label="Photo Proof"
						file={formData.photoProof}
						type="Photo Proof"
						error={errors["Photo Proof"]}
						onChange={handleFileChange}
						onRemove={removeFile}
						onSelect={(e) => { const uploadedFile = e.files?.[0]; setFormData({ ...formData, photoProof: uploadedFile }) }}
					/>
				</div>
				<EmergencyContact errors={errors} setErrors={setErrors}/>

				<MedicalInformation errors={errors} setErrors={setErrors}/>

				<Membership errors={errors} setErrors={setErrors}/>

			</form>
		</div>
	);
};

export default PersonalInformation;
